/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, ListGroup, Row, Col, Image } from 'react-bootstrap';
import * as S from './styles';

export interface IListItemsProps {
  image?: string;
  title?: string;
  description?: string;
  value?: string;
  link?: string;
}

export interface IListItemWidgetProps {
  title: string;
  listItems?: IListItemsProps[];
  onItemClick?(item: any): void;
}

const getFirstLetterOfEachWord = (text) => text?.match(/\b\w/g).join('');

export const ListItemComp = ({
  title,
  listItems,
  onItemClick,
}: IListItemWidgetProps) => {
  const _renderTitle = () => {
    if (title) {
      return (
        <Card.Header className="border-bottom">
          <h2 className="fs-5 fw-bold mb-0">{title}</h2>
        </Card.Header>
      );
    }
  };

  const onListItemClick = (item: any) => {
    onItemClick && onItemClick(item);
    // console.log(`selected item`, item);
  };

  const _renderImageIf = (item: any) => {
    if (item?.image) {
      return (
        <Col xs="auto">
          <Card.Link className="avatar-md">
            <Image rounded src={item?.image} className="m-0" />
          </Card.Link>
        </Col>
      );
    }
    if (item?.title) {
      return (
        <Col xs="auto">
          {/* <Card.Link href={item?.link ?? "#"} className="avatar-md"> */}
          <div
            className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary"
            style={S.AuthorImageStyle}
          >
            <span>{getFirstLetterOfEachWord(item?.title)}</span>
          </div>
          {/* </Card.Link> */}
        </Col>
      );
    }
    return null;
  };
  const _renderProfileIf = (item: any) => {
    if (item?.title) {
      return (
        <Col xs="auto" className="px-0">
          <h4 className="fs-6 text-dark mb-0">
            {/* <Card.Link href={item?.link ?? "#"}> */}
            {item?.title}
            {/* </Card.Link> */}
          </h4>
          {item?.description && <small>{item?.description}</small>}
        </Col>
      );
    }
  };
  const _renderValueIf = (item: any) => {
    if (item?.value) {
      return (
        <Col className="text-end">
          <span className="fs-6 fw-bolder text-dark">{item?.value}</span>
        </Col>
      );
    }
  };
  const _renderCardBody = () => {
    if (listItems) {
      return (
        <Card.Body className="py-0">
          <ListGroup className="list-group-flush">
            {listItems?.map((item, index) => (
              <S.ListGroupItem
                key={`list-item-${index}`}
                className="bg-transparent border-bottom py-3 px-0"
                onClick={() => onListItemClick(item)}
              >
                <Row className="align-items-center">
                  {_renderImageIf(item)}
                  {_renderProfileIf(item)}
                  {_renderValueIf(item)}
                </Row>
              </S.ListGroupItem>
            ))}
          </ListGroup>
        </Card.Body>
      );
    }
  };
  return (
    <Card border="0" className="shadow">
      {_renderTitle()}
      {_renderCardBody()}
    </Card>
  );
};

ListItemComp.defaultProps = {
  listItems: [],
};
